import * as ActionTypes from './actionTypes.js';
import _ from 'lodash';

export default function quotesSummaryReducers(state = {}, action) {
    switch (action.type) {
        case ActionTypes.QUOTES_SUMMARY_LIST:
            return Object.assign({}, state, action.payload, { showErrors: false });
        case ActionTypes.QUOTES_SUMMARY_LIST_PAGINATION:
            let payloadReceived = action.payload;
            let currentBatchSummary = action.payload?.quotes?.summary;
            let paginatedDetails = currentBatchSummary.metadata?.pages?.pageNumber === 1 ? [] : state.quotes?.summary?.results;
            if (currentBatchSummary.metadata?.pages?.pageNumber * currentBatchSummary.metadata?.pages?.pageSize > paginatedDetails?.length ) {
                 if(currentBatchSummary?.metadata?.pages?.totalElements > paginatedDetails.length)
                paginatedDetails = paginatedDetails.concat(currentBatchSummary?.results);
            }
            payloadReceived.quotes.summary.results = paginatedDetails;
            return Object.assign({}, state, action.payload, { showErrors: false });

        case ActionTypes.QUOTES_SUMMARY_LIST_FETCH_FAILED:
        case ActionTypes.SET_QUOTES_SUMMARY_LOADING:
        case ActionTypes.SHOW_PAGINATION_PROGRESS:
            return _.extend({}, state, action.payload);
        case ActionTypes.RESET_QUOTES_SUMMARY:
            return {};
        default:
            return state;
    }
}
